<template>
	<TheHeader></TheHeader>

	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>

					<ThePageLoading v-if="isPageLoading"></ThePageLoading>

					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deleteConsoGroup" :renderDelete="(identifier != null ? true : false)" :isDeleting="isDeleting"></ThePageHeader>

						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Parent Company:</label>
									</div>
									<div class="col-md-6">
										<Dropdown :options="filteredParentCompanies" optionLabel="code" optionValue="identifier" filter :filterFields="['code', 'name']" showClear :placeholder="isParentCompanyLoading ? ('Loading...') : '-- Please Select --'" :loading="isParentCompanyLoading" v-model="consoGroup.parentCompany.identifier" :disabled="identifier != null" @change="updateCompanyDropdown">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCompanyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCompanyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Purpose:</label>
									</div>
									<div class="col-md-6">
										<Dropdown :options="purposes" optionLabel="name" optionValue="identifier" filter :filterFields="['name']" showClear :placeholder="isPurposeLoading ? ('Loading...') : '-- Please Select --'" :loading="isPurposeLoading" v-model="consoGroup.purpose.identifier" :disabled="identifier != null"></Dropdown>
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Month:</label>
									</div>
									<div class="col-md-6">
										<Calendar v-model="date" @update:modelValue="updateConsoGroupDate" view="month" :manualInput="true" dateFormat="M yy" placeholder="Conso Group Month" showIcon :disabled="identifier != null"/>
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3">
										<label class="col-form-label-title">Conso Group Name:</label>
									</div>

									<div class="col-md-6">
										<InputText v-model="consoGroupName" readonly></InputText>
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3">
										<label class="col-form-label-title">Conso Group Description:</label>
									</div>

									<div class="col-md-6">
										<Textarea v-model="consoGroup.description" rows="1" maxlength="1000" />
									</div>
								</div>

								<Divider></Divider>

								<div class="row">
									<div class="col-md-3">
										<label class="col-form-label-title">Assign Company:</label>
									</div>

									<div class="col-md-6">
										<MultiSelect :virtualScrollerOptions="{ itemSize: 44 }" :options="filteredChildCompanies" optionLabel="code" display="chip" filter :filterFields="['code', 'name']" showClear :placeholder="isChildCompanyLoading ? ('Loading...') : '-- Please Select --'" :loading="isChildCompanyLoading" v-model="selectedChildCompanies" :disabled="consoGroup.purpose.identifier == null">
											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</MultiSelect>
									</div>

									<div class="col-md-3">
										<Button class="p-button-sm" label="Add" @click="addChildCompany(false)" :disabled="selectedChildCompanies == null || selectedChildCompanies.length == 0 || consoGroup.purpose.identifier == null || consoGroup.consoGroupYear == null || consoGroup.consoGroupMonth == null"></Button>
										<Button class="p-button-sm ms-2" label="Add All" @click="addChildCompany(true)" :disabled="filteredChildCompanies.length == 0 || consoGroup.purpose.identifier == null || consoGroup.consoGroupYear == null || consoGroup.consoGroupMonth == null"></Button>
									</div>
								</div>

								<div class="row py-3 sticky-component">
									<div class="col-md-12">
										<Button class="p-button-icon-only me-2" :disabled="selectedChildSequence == null" aria-label="Filter" @click="moveUp">
											<FontAwesomeIcon :icon="['fas', 'fa-arrow-up']" size="sm" width="18px"></FontAwesomeIcon>
										</Button>
										<Button class="p-button-icon-only me-2" :disabled="selectedChildSequence == null" aria-label="Filter" @click="moveDown">
											<FontAwesomeIcon :icon="['fas', 'fa-arrow-down']" size="sm" width="18px"></FontAwesomeIcon>
										</Button>
										<Button class="p-button-icon-only me-2" :disabled="selectedChildSequence == null" aria-label="Filter" @click="moveTop">
											<FontAwesomeIcon :icon="['fas', 'fa-arrows-up-to-line']" size="sm" width="18px"></FontAwesomeIcon>
										</Button>
										<Button class="p-button-icon-only me-2" :disabled="selectedChildSequence == null" aria-label="Filter" @click="moveBottom">
											<FontAwesomeIcon :icon="['fas', 'fa-arrows-down-to-line']" size="sm" width="18px"></FontAwesomeIcon>
										</Button>
									</div>
								</div>

								<div class="row mt-3 mb-2">
									<div class="conso-company-table-label mr-4">{{ filterCompanyCodeByValue(consoGroup.parentCompany.identifier) }}</div>
									<div class="conso-company-table-label">{{ filterCompanyNameByValue(consoGroup.parentCompany.identifier) }}</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-12">
										<DataTable class="conso-company-table" :value="consoGroup.consoGroupCompanies" v-model:selection="selectedChildSequence" :metaKeySelection="false" selectionMode="single">
											<Column style="width: 3%" header="">
												<template #body="slotProps">
													<i class="pi pi-exclamation-triangle align-text-bottom " style="color:var(--bs-warning)" v-tooltip.left="'Group is undefined'" v-if="slotProps.data.isGroup && slotProps.data.consoGroupId == null" />
													<i class="pi pi-check align-text-bottom" style="color:var(--bs-success)" v-else-if="slotProps.data.isGroup && slotProps.data.consoGroupId != null"></i>
												</template>
											</Column>
											<Column style="width: 3%" header="#">
												<template #body="slotProps">
													{{ slotProps.index + 1 }}
												</template>
											</Column>

											<Column style="width:10%" field="company.code" header="Code"></Column>
											<Column style="width:62%" header="Name">
												<template #body="slotProps">
													<Button class="p-button-link p-0" :label="slotProps.data.company.name" @click="navigateTo(slotProps.data)" v-if="slotProps.data.isGroup" />
													<span v-else>{{ slotProps.data.company.name }}</span>
												</template>
											</Column>
											<Column style="width: 12%" header="has CWK">
												<template #body="slotProps">
													<Checkbox v-model="slotProps.data.isGroup" :binary="true" @change="checkConsoGroupExist(slotProps.data)"></Checkbox>
												</template>
											</Column>

											<Column style="width: 10%" header="">
												<template #body="slotProps">
													<Button icon="pi pi-trash" severity="danger" text rounded @click="removeChildCompany(slotProps.index)" title="Delete" />
												</template>
											</Column>

											<template #empty>
												<div class="error-no-record mt-3" v-if="consoGroup.consoGroupCompanies.length <= 0">
													<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
													<h6><span>No Record Found</span></h6>
												</div>
											</template>

										</DataTable>


									</div>


								</div>

								<div class="row mb-3">
									<div class="col-md-3"></div>

									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.consoGroup.$invalid || isLoading" @click="identifier == null ? save() : update()" label="Save" />
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel" />

										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>

						<!-- <TheInvalidImportDialog title="Conso Group Company" :visible="isDialogVisible" :data="invalidData" @close-dialog-event="closeDialog" @proceed-import-event="proceedImport"></TheInvalidImportDialog> -->

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>

					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>

	<TheConfirmationDialog :loading="confirmationDialog.isLoading" :visible="confirmationDialog.isVisible" :header="confirmationDialog.header" :message="confirmationDialog.message" status="" @confirm="onDialogConfirm" @cancel="onDialogCancel"></TheConfirmationDialog>

</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import companyApi from "@/api/company-api";
	import consoGroupApi from "@/api/consogroup-api";
	import consoGroupCompanyApi from "@/api/consogroupcompany-api";
	import purposeApi from "@/api/purpose-api";
	import statusMixin from "@/mixin/status";
	import dateUtilsMixin from "@/mixin/utils/date-utils"

	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheInvalidImportDialog from "@/components/TheInvalidImportDialog.vue";
	import TheConfirmationDialog from "@/components/TheConfirmationDialog.vue";

	import useVuelidate from "@vuelidate/core";
	import { required } from "@vuelidate/validators";
	import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

	export default defineComponent({
		mixins: [statusMixin, dateUtilsMixin],
		components: {
			FontAwesomeIcon,
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
			// TheInvalidImportDialog,
			TheConfirmationDialog,
		},
		data() {
			return {
				pageError: (!store.getters.getError ? '' : store.getters.getError),
				identifier: useRoute().params.id,
				companyId: useRoute().params.companyId,
				purposeId: useRoute().params.purposeId,
				date: null as any,
				year: (useRoute().params.year != null && useRoute().params.year != "") ? useRoute().params.year : new Date().getFullYear(),
				month: (useRoute().params.month != null && useRoute().params.month != "") ? useRoute().params.month : new Date().getMonth(),
				consoGroup: {
					name: '', 
					description: '', 
					purpose: {identifier: null as any}, 
					parentCompany: {identifier: null as any}, 
					consoGroupYear: null as any,
					consoGroupMonth: null as any,
					consoGroupCompanies: [] as any[], isClosed: false
				},
				currentGroupId: null as any,
				companies: [] as any[],
				filteredCompanies: [] as any[],
				filteredParentCompanies: [] as any[],
				filteredChildCompanies: [] as any[],
				purposes: [] as any[],
				isPageLoading: false,
				isLoading: false,
				// isImporting: false,
				// isExporting: false,
				isDialogVisible: false,
				invalidData: {} as any,
				isPurposeLoading: false,
				isParentCompanyLoading: false,
				isChildCompanyLoading: false,
				isDeleting: false,
				childCompanies: [] as any[],
				selectedChildCompanies: [] as any[],
				selectedChildSequence: null as any,
				confirmationDialog: {consoGroupCompany: null as any, header: "", message: "", isVisible: false, isLoading: false},
			};
		},
		watch: {
			consoGroupName(newValue: any) {
				this.consoGroup.name = newValue;
			},
			filterLegalGroupId(newValue: any) {
				this.isParentCompanyLoading = true;
				this.isChildCompanyLoading = true;
				companyApi.companyList({}, this.filterLegalGroupId)
					.then(response => {
						this.filteredCompanies = response.data.listSet;
						this.selectedChildCompanies = null as any;
						this.updateCompanyDropdown();

						this.isParentCompanyLoading = false;
						this.isChildCompanyLoading = false;
					})
					.catch(error => {
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						this.isParentCompanyLoading = false;
						this.isChildCompanyLoading = false;
					});
			}
		},
		computed: {
			filterLegalGroupId() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null);
			},
			consoGroupName() {
				if (this.identifier == null) {
					if (this.consoGroup.parentCompany.identifier != null && this.consoGroup.purpose.identifier != null && this.consoGroup.consoGroupYear != null && this.consoGroup.consoGroupMonth != null) {
						return "Group-" + this.filterCompanyCodeByValue(this.consoGroup.parentCompany.identifier) + "-" + this.consoGroup.consoGroupYear + "-" + this.consoGroup.consoGroupMonth + "-" + this.filterPurposeCodeByValue(this.consoGroup.purpose.identifier);
					}
					return "";
				}
				return this.consoGroup.name;
			}
		},
		mounted: function () {
			if (this.pageError == '') {
				if (this.companyId != null && this.purposeId != null && this.year != null && this.month != null ) {
					this.consoGroup.parentCompany.identifier = Number(this.companyId);
					this.consoGroup.purpose.identifier = Number(this.purposeId);
					this.consoGroup.consoGroupYear = this.year;
					this.consoGroup.consoGroupMonth = this.month;
				}

				this.isPageLoading = true;

				let r1 = companyApi.companyList({}, null);

				let r2 = companyApi.companyList({}, this.filterLegalGroupId);

				let r3 = purposeApi.purposeList({});

				let r4 = null;
				if (this.identifier != null) {
					r4 = consoGroupApi.consoGroupView(this.identifier)
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						});
				}

				Promise.all([r1, r2, r3, r4])
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == 0) {
												this.companies = values[i].data.listSet;
											}

											else if (i == 1) {
												this.filteredCompanies = values[i].data.listSet;
											}

											else if (i == 2) {
												this.purposes = values[i].data.listSet;
											}

											else if (i == 3) {
												this.consoGroup = values[i].data.consoGroup;
											}
										}
									}
								}
							}
							this.updateCompanyDropdown();
						}
						this.isPageLoading = false;
						this.updateDate();
					})
					.catch(error => {
						this.isPageLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			}
		},
		methods: {
			filterPurposeCodeByValue: function (value: any) {
				let purposes = this.purposes.filter(function (purpose: any) {
					if (purpose.identifier == value) {
						return purpose;
					}
				});

				if (purposes != null && purposes.length > 0) {
					return purposes[0].code;
				}
				return null;
			},
			filterPurposeNameByValue: function (value: any) {
				let purposes = this.purposes.filter(function (purpose: any) {
					if (purpose.identifier == value) {
						return purpose;
					}
				});

				if (purposes != null && purposes.length > 0) {
					return purposes[0].name;
				}
				return null;
			},
			filterCompanyCodeByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});

				if (companies != null && companies.length > 0) {
					return companies[0].code;
				}
				return null;
			},
			filterCompanyNameByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});

				if (companies != null && companies.length > 0) {
					return companies[0].name;
				}
				return null;
			},
			save() {
				this.isLoading = true;
				this.setSequence();
				consoGroupApi.consoGroupSave({consoGroup: this.consoGroup})
					.then((response: any) => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						if (response.data.consoGroup != null) {
							this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
							this.$router.push("/admin/consoGroup/view/" + response.data.consoGroup.identifier);
						}
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			update() {
				this.isLoading = true;
				this.setSequence();
				consoGroupApi.consoGroupUpdate({consoGroup: this.consoGroup})
					.then((response: any) => {
						this.isLoading = false;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			deleteConsoGroup() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this conso group?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						consoGroupApi.consoGroupDelete({consoGroup: this.consoGroup})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isLoading = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/admin/consoGroup");
							})
							.catch(error => {
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
								this.isLoading = false;
							});
					}
				})
			},
			moveUp() {
				let index = this.consoGroup.consoGroupCompanies.findIndex(consoGroupCompany => consoGroupCompany.company.identifier == this.selectedChildSequence.company.identifier);
				if (index != -1 && index != 0) {
					this.consoGroup.consoGroupCompanies.splice(index - 1, 0, this.consoGroup.consoGroupCompanies.splice(index, 1)[0]);
				}
			},
			moveDown() {
				let index = this.consoGroup.consoGroupCompanies.findIndex(consoGroupCompany => consoGroupCompany.company.identifier == this.selectedChildSequence.company.identifier);
				if (index != -1 && index != this.consoGroup.consoGroupCompanies.length) {
					this.consoGroup.consoGroupCompanies.splice(index + 1, 0, this.consoGroup.consoGroupCompanies.splice(index, 1)[0]);
				}
			},
			moveTop() {
				let index = this.consoGroup.consoGroupCompanies.findIndex(consoGroupCompany => consoGroupCompany.company.identifier == this.selectedChildSequence.company.identifier);
				if (index != -1 && index != 0) {
					this.consoGroup.consoGroupCompanies.splice(0, 0, this.consoGroup.consoGroupCompanies.splice(index, 1)[0]);
				}
			},
			moveBottom() {
				let index = this.consoGroup.consoGroupCompanies.findIndex(consoGroupCompany => consoGroupCompany.company.identifier == this.selectedChildSequence.company.identifier);
				if (index != -1 && index != this.consoGroup.consoGroupCompanies.length) {
					this.consoGroup.consoGroupCompanies.splice(this.consoGroup.consoGroupCompanies.length, 0, this.consoGroup.consoGroupCompanies.splice(index, 1)[0]);
				}
			},
			setSequence() {
				for (let i = 0; i < this.consoGroup.consoGroupCompanies.length; i++) {
					this.consoGroup.consoGroupCompanies[i].sequence = i + 1;
				}
			},
			addChildCompany(isAddAll: boolean) {
				if (isAddAll) {
					for (let i = 0; i < this.filteredChildCompanies.length; i++) {
						if (!this.consoGroup.consoGroupCompanies.find(c => c.company.identifier == this.filteredChildCompanies[i].identifier)) {
							this.consoGroup.consoGroupCompanies.push({company: this.filteredChildCompanies[i], sequence: this.consoGroup.consoGroupCompanies.length + 1, isGroup: false});
						}
					}
				}

				else {
					for (let i = 0; i < this.selectedChildCompanies.length; i++) {
						if (!this.consoGroup.consoGroupCompanies.find(c => c.company.identifier == this.selectedChildCompanies[i].identifier)) {
							this.consoGroup.consoGroupCompanies.push({company: this.selectedChildCompanies[i], sequence: this.consoGroup.consoGroupCompanies.length + 1, isGroup: false});
						}
					}
					this.selectedChildCompanies = [] as any[];
				}
			},
			removeChildCompany(index: any) {
				if (this.identifier != null && this.consoGroup.consoGroupCompanies[index].identifier != null) {
					consoGroupCompanyApi.consoGroupCompanyCheckExistByCWK({'consoGroup': this.consoGroup, 'consoGroupCompany': this.consoGroup.consoGroupCompanies[index]})
					.then(response => {
						if (response.data.status) {
							if (this.consoGroup.consoGroupCompanies[index].consoGroupId != null) {
								this.$confirm.require({
									message: 'Conso group definition exist. Further action is required to remove it completely.',
									header: 'Note',
									icon: 'pi pi-exclamation-triangle',
									rejectLabel: 'Cancel',
									acceptLabel: 'Ok',
									accept: () => {
										consoGroupCompanyApi.consoGroupCompanyCheckExistByCWK({'consoGroup': this.consoGroup, 'consoGroupCompany': this.consoGroup.consoGroupCompanies[index]})
											.then(response => {
												if (response.data.status) {
													this.consoGroup.consoGroupCompanies.splice(index, 1);
												}
											})
											.catch(error => {
												this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
											});

									},
								});
							}

							else {
								this.$confirm.require({
									header: 'Confirmation',
									message: 'Are you sure you want to remove this company?',
									icon: 'pi pi-trash',
									accept: () => {
										this.consoGroup.consoGroupCompanies.splice(index, 1);
									}
								});
							}
						}
					})
					.catch(error => {
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
				}
				else {
					this.$confirm.require({
						header: 'Confirmation',
						message: 'Are you sure you want to remove this company?',
						icon: 'pi pi-trash',
						accept: () => {
							this.consoGroup.consoGroupCompanies.splice(index, 1);
						}
					});
				}
			},
			updateCompanyDropdown() {
				if (this.filterLegalGroupId != null) {
					this.filteredChildCompanies = [...this.filteredCompanies];

					if (this.identifier == null && this.companyId == null) {
						this.filteredParentCompanies = [...this.filteredCompanies];
					}

					else {
						this.filteredParentCompanies = [...this.companies];
					}
				}

				else {
					this.filteredParentCompanies = [...this.companies];
					this.filteredChildCompanies = [...this.companies];
				}

				if (this.consoGroup.parentCompany.identifier != null) {
					this.filteredParentCompanies = [...this.companies];
					let index = this.filteredChildCompanies.findIndex(childCompany => childCompany.identifier == this.consoGroup.parentCompany.identifier);
					if (index != -1) {
						this.filteredChildCompanies.splice(index, 1);
					}
				}

				else {
					this.filteredChildCompanies = [...this.filteredCompanies];
				}
			},
			navigateTo(consoGroupCompany: any) {
				this.confirmationDialog.header = "Warning. You're leaving this page!";
				this.confirmationDialog.message = "All changes made will be unsaved. Do you want to leave this page?";
				this.confirmationDialog.isVisible = true;
				this.confirmationDialog.consoGroupCompany = consoGroupCompany;
				document.body.classList.add("dialog-open");
			},
			onDialogConfirm() {
				document.body.classList.remove("dialog-open");
				this.confirmationDialog.isVisible = false;
				if (this.confirmationDialog.consoGroupCompany.consoGroupId != null) {
					this.$router.push('/admin/consogroup/view/' + this.confirmationDialog.consoGroupCompany.consoGroupId);
				}

				else {
					this.$router.push('/admin/consogroup/add/' + this.confirmationDialog.consoGroupCompany.company.identifier + '/' + this.consoGroup.purpose.identifier + '/' + this.consoGroup.consoGroupYear + '/' + this.consoGroup.consoGroupMonth);
				}
			},
			onDialogCancel() {
				document.body.classList.remove("dialog-open");
				this.confirmationDialog.isVisible = false;
			},
			checkConsoGroupExist(consoGroupCompany: any) {
				if (consoGroupCompany.isGroup) {
					consoGroupApi.consoGroupFindByCompanyId({consoGroup: this.consoGroup, companyId: consoGroupCompany.company.identifier})
						.then((response: any) => {
							let index = this.consoGroup.consoGroupCompanies.findIndex(tmpConsoGroupCompany => tmpConsoGroupCompany.company.identifier == consoGroupCompany.company.identifier);
							if (response.data.consoGroup == null) {
								this.consoGroup.consoGroupCompanies[index].consoGroupId = null;
							}

							else {
								this.consoGroup.consoGroupCompanies[index].consoGroupId = response.data.consoGroup.identifier;
							}
						})
						.catch(error => {
							console.log(error);
						});
				}

				else if (consoGroupCompany.consoGroupId != null) {
					this.$confirm.require({
						message: 'Conso group definition exist. Further action is required to remove it completely.',
						header: 'Note',
						icon: 'pi pi-exclamation-triangle',
						rejectClass: 'd-none',
						acceptLabel: 'Ok',
						accept: () => {
							// this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 6000 });
						},
						reject: () => {
							// this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 6000 });
						}
					});
				}

			},
			cancel() {
				// Go back to the previous screen (conso group list) so its last filter/sort
				// display is preserved, instead of a fresh navigation. Fall back to the list
				// route when there is no history entry (e.g. opened via direct URL).
				const state = window.history.state as any;
				if (state?.back) {
					this.$router.back();
				} else {
					this.$router.push("/admin/consoGroup");
				}
			},
			// importFile(file: any) {
			// 	this.isImporting = true;

			// 	var formData = new FormData();
			// 	formData.append('file', file[0]);

			// 	consoGroupApi.consoGroupImport(formData)
			// 		.then((response: any) => {
			// 			this.isImporting = false;
			// 			this.invalidData = response.data;
			// 			this.isDialogVisible = true;
			// 		})
			// 		.catch(error => {
			// 			this.isImporting = false;
			// 			this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
			// 		});
			// },
			// proceedImport(isOverride: boolean) {
			// 	this.isImporting = true;

			// 	let tempInvalidData = JSON.parse(JSON.stringify(this.invalidData));

			// 	if (isOverride == false && tempInvalidData.warningCount > 0) {
			// 		tempInvalidData.invalidRows.forEach((invalidRow: any, index: any) => {
			// 			if (invalidRow.type == "Warning") {
			// 				invalidRow.type = "Error";
			// 				return invalidRow;
			// 			}
			// 		});
			// 	}

			// 	consoGroupApi.consoGroupImportProceed({'invalidData': tempInvalidData})
			// 		.then((response: any) => {
			// 			this.isImporting = false;
			// 			this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
			// 			this.isDialogVisible = false;
			// 			this.consoGroup.consoGroupCompanies = [] as any[];
			// 			var companies = response.data.listSet;
			// 			for (let i = 0; i < companies.length; i++) {
			// 				this.consoGroup.consoGroupCompanies.push({company: companies[i], sequence: this.consoGroup.consoGroupCompanies.length + 1, isGroup: companies[i].group.toUpperCase() == "TRUE"});
			// 			}
			// 		})
			// 		.catch(error => {
			// 			this.isImporting = false;
			// 			this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
			// 		});
			// },
			// exportFile() {
			// 	this.isExporting = false;

			// 	consoGroupApi.consoGroupExport({consoGroup: this.consoGroup})
			// 		.then(response => {
			// 			this.isExporting = false;
			// 		})
			// 		.catch(error => {
			// 			this.isExporting = false;
			// 			this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
			// 		});
			// },
			closeDialog() {
				this.isDialogVisible = false;
			},
			updateConsoGroupDate() {
				this.consoGroup.consoGroupYear = this.date.getFullYear();
				this.consoGroup.consoGroupMonth = this.date.getMonth() + 1;
			},
			updateDate(){
				if (this.consoGroup.consoGroupYear && this.consoGroup.consoGroupMonth){
					this.date = new Date(Number(this.consoGroup.consoGroupYear), Number(this.consoGroup.consoGroupMonth)-1);
				}
			}
		},
		setup() {
			return {v$: useVuelidate()};
		},
		validations() {
			return {
				consoGroup: {
					parentCompany: {
						identifier: {
							required
						}
					},
					purpose: {
						required
					},
					name: {
						required
					},
					consoGroupYear: {
						required
					},
					consoGroupMonth: {
						required
					},
				}
			};
		}
	});
</script>
